/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { AnyAction } from '@reduxjs/toolkit';
import { all, call, put, takeEvery } from 'redux-saga/effects';

import * as api from '@ibm-watson/shared/modules/dialog/api/conflicts';
import * as actions from './actions';
import * as actionType from './actionTypes';

export function* fetchAllIntentConflicts(action: AnyAction) {
  try {
    const data = yield call(
      api.getAllIntentConflicts,
      action.workspaceId,
      action.skillId,
      action.useNewIAUpdatedAccess,
      action.assistantId
    );
    yield put(actions.getAllIntentConflictsSuccess(data));
  } catch (error) {
    yield put(actions.getAllIntentConflictsError(error));
  }
}

export function* fetchConflictsForIntent(action: AnyAction) {
  try {
    const data = yield call(
      api.getConflictsForIntent,
      action.workspaceId,
      action.intentName,
      action.skillId,
      action.useNewIAUpdatedAccess,
      action.assistantId
    );
    yield put(actions.getConflictsForSingleIntentSuccess(data));
  } catch (error) {
    yield put(actions.getConflictsForSingleIntentError(error));
  }
}

export function* fetchConflictsForExample(action: AnyAction) {
  try {
    const data = yield call(
      api.getConflictsForExample,
      action.workspaceId,
      action.intentName,
      action.exampleId,
      action.skillId,
      action.useNewIAUpdatedAccess,
      action.assistantId
    );
    yield put(actions.getConflictsForIntentExampleSuccess(data));
  } catch (error) {
    yield put(actions.getConflictsForIntentExampleError(error));
  }
}

function* watchFetchAllIntentConflicts() {
  yield takeEvery(
    actionType.FETCH_ALL_INTENT_CONFLICTS,
    fetchAllIntentConflicts
  );
}
function* watchFetchConflictsForIntent() {
  yield takeEvery(
    actionType.FETCH_SINGLE_INTENT_CONFLICTS,
    fetchConflictsForIntent
  );
}
function* watchFetchConflictsForExample() {
  yield takeEvery(
    actionType.FETCH_INTENT_EXAMPLE_CONFLICTS,
    fetchConflictsForExample
  );
}

export default function* rootSaga() {
  yield all([
    watchFetchAllIntentConflicts(),
    watchFetchConflictsForIntent(),
    watchFetchConflictsForExample()
  ]);
}
